import type { LoyaltyInfo } from '../model/types';

export const loyaltyUtils = () => {
  const setLoyaltyInfo = (data: Partial<LoyaltyInfo>) => {
    // Здесь можно добавить дополнительную логику
    return { ...data };
  };

  return {
    setLoyaltyInfo,
  };
};